(function() { module.exports = window["Bernie_l10nBundle_el_GR"]; }());